module.exports = require('./helpers/bundle-url').getBundleURL('7lpHJ') + "logo.54b3d73e.png";